var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/uploading") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.1874781,7.20315551 C13.1874781,7.74456848 13.6304378,8.18752816 14.1718507,8.18752816 L19.7499624,8.18752816 L19.7499624,21.6406211 C19.7499624,22.1861196 19.3110883,22.6249937 18.7655898,22.6249937 L4.98437265,22.6249937 C4.43887415,22.6249937 4,22.1861196 4,21.6406211 L4,2.60941646 C4,2.06391796 4.43887415,1.62504381 4.98437265,1.62504381 L13.1874781,1.62504381 L13.1874781,7.20315551 Z M15.8608573,16.0629099 C16.4465703,16.0629099 16.7386056,15.3537499 16.322282,14.9407507 L12.3675681,11.0155568 C12.0948389,10.7444297 11.6543225,10.7444297 11.3815532,11.0155568 L7.42683929,14.9407507 C7.01095626,15.3537499 7.30339216,16.0629099 7.88910511,16.0629099 L10.5624844,16.0629099 L10.5624844,19.3441521 C10.5624844,19.706723 10.8561619,20.0004005 11.2187328,20.0004005 L12.5312297,20.0004005 C12.8938005,20.0004005 13.1874781,19.706723 13.1874781,19.3441521 L13.1874781,16.0629099 L15.8608573,16.0629099 Z M19.4628538,5.93167417 C19.6474236,6.11624404 19.7499624,6.36642273 19.7499624,6.6248526 L19.7499624,6.87503129 L14.499975,6.87503129 L14.499975,1.62504381 L14.7501537,1.62504381 C15.0126691,1.62504381 15.2628478,1.72758263 15.4474176,1.9121525 L19.4628538,5.93167417 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/uploading",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "file-upload",
    fill: "#40B3DB",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploading);
export default __webpack_public_path__ + "static/media/uploading.9286cb11.svg";
export { ForwardRef as ReactComponent };